import { Map } from 'immutable';
import { efectorlistActions } from '../efector-lists';
import { practiceActions } from '../practices';
import { createEfector, Efector } from './efector';
import { efectorActions } from './actions';
import { DEFAULT_SESSION_ID, DEFAULT_PER_PAGE } from '../constants';

export function efectoresReducer(state = new Map(), action) {
  const {payload, type} = action
  switch (type) {
    case efectorlistActions.FETCH_EFECTORES_SUCCESS:
      return state.withMutations( efectores => {
        payload.data.forEach( efectorData => {
          if (!efectores.has(efectorData.id)) {
            efectores.set(efectorData.id, createEfector(efectorData));
          }
        });
      });
    case practiceActions.FETCH_PRACTICE_SUCCESS:
      return state.withMutations( efectores => {
        payload.data.forEach( practiceData => {
          if (!efectores.has(practiceData.id_efector)) {
            efectores.set(practiceData.efector.id, createEfector(practiceData.efector));
          }
        });
      });

    case efectorActions.DELETE_EFECTOR:
      return state.filter( efector => efector.id !== payload.efectorId)
    case efectorActions.FETCH_EFECTOR_FAILED:
      alert(payload.error.message)
      if ( payload.efectorId )
        return state.set(
          payload.efectorId,
          efectorReducer(state.get(payload.efectorId), action)
        );
      return state;
    case efectorActions.FETCH_EFECTOR_SUCCESS:
      return state.set(
        payload.efectorId,
        efectorReducer(state.get(payload.efectorId), action)
        );
    case efectorActions.FETCH_EFECTOR_PENDING:
      return state.set(
        payload.efectorId,
        efectorReducer(state.get(payload.efectorId), action)
      );
    case efectorActions.LOAD_EFECTOR:
      return state.set(
        payload.efectorId,
        efectorReducer(state.get(payload.efectorId), action)
      );
    default:
      return state;
  }
}

export const efectorReducer = (state = new Efector() , { payload, type }  ) => {
  switch (type) {
    case efectorActions.FETCH_EFECTOR_SUCCESS:
      return state.withMutations( efector => {
        efector.merge(createEfector(payload.efector));
      });
    case efectorActions.FETCH_EFECTOR_FAILED:
      return state.set('isPending', false);
    case efectorActions.FETCH_EFECTOR_PENDING:
      return state.set('isPending', true);
    case efectorActions.LOAD_EFECTOR:
      return state.set('id', payload.efectorId);
    default:
      return state;
  }
}
